import React, { useEffect, useRef, useState } from "react"
import Select from 'react-select';
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import { modalsSelector } from "../../selectors";
import { isEmpty } from "lodash";
import { roleId, urls } from "../../constants/app";
import request from "../../action/utils/request";
import swal from 'sweetalert';
import { addArticleWorkingShift, pingExtension, requestAtol } from "../../action/cassa";
import { setFiscalDataOrder } from "../../action/orders";
import { styles } from "../goods/styles";
import { comparisonVersionExtension } from "../../utils/common";

const RefundOrderModal = (props) => {
    const ref = useRef();
    const dispatch = useDispatch();

    const inital = useSelector(modalsSelector).refundOrderModal;
    const [ cashier, setCashier ] = useState();
    const [ loading, setLoading ] = useState(true);
    const [ availableCashiers, setAvailableCashiers ] = useState();

    const { device, workingShift, order, point } = inital;

    const onClose = () => dispatch(setActiveModalAction({ field: 'refundOrderModal', value: null }));

    useEffect(() => {
        if (!loading) return;
        
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
            return e.returnValue;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        
        const unblock = props.history.block((location, action) => {
            return 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
        });
        
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            if (unblock) unblock();
        };
    }, [loading, props.history]);

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const params = {
                'role.id_in': roleId.cashier,
                'inn_null': false,
                'name_null': false,
                'points.id_in': point.id,
            };

            const cashiers = await request({ method: 'get', url: urls.users, params });
            if (cashiers && cashiers.length > 0) {
                setAvailableCashiers(cashiers.map((item) => ({ label: item.name, value: item.id, inn: item.inn, name: item.name })));
                setLoading(false);
            } else {
                return swal({
                    title: "Кассиры не найдены",
                    text: "Возврат заказа не возможен",
                    icon: "warning",
                    button: "Ок",
                }).then(() => onClose());
            }
        }

        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [point]);
    
    useOnClickOutside(ref, onClose);

    const onSubmit = async () => {
        setLoading('kkt');

        const requestData = {
            order,
            point,
            ffd: device.ffd || 1.2,
            type: 'sellReturn',
            forceCashier: { inn: cashier.inn, name: cashier.name },
            host: device.host ? device.host : "http://127.0.0.1",
            port: device.port ? device.port : "16732",
            login: device.login,
            password: device.password,
        }

        const ping = await dispatch(pingExtension());
        if (!ping) return swal({
            title: "Фискализация заказа невозможна",
            text: '101. Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.',
            icon: "error",
            button: "Ок",
        });

        const versionExtension = ping.version;
        
        const fiscalization = await dispatch(requestAtol(requestData, false));

        if (!fiscalization) {
            setLoading(false);
            return swal({
                title: "Ошибка возврата",
                text: 'Неизвестная ошибка',
                icon: "error",
                button: "Ок",
            });
        }

        if (fiscalization.isBlocked) {
            setLoading(false);
            return swal({
                title: "Ошибка возврата",
                text: 'Операция заблокирована ККТ.',
                icon: "error",
                button: "Ок",
            });
        }

        if (!comparisonVersionExtension(versionExtension, '2.2.2') && fiscalization.error && !fiscalization.fiscalUUID && !fiscalization.uuid) {
            setLoading(false);
            return swal({
                title: "Ошибка возврата",
                text: `${fiscalization.error.code ? `Код ошибки: ${fiscalization.error.code} ` : ''}${fiscalization.error.description || fiscalization.error.message ? `. ${fiscalization.error.description || fiscalization.error.message}` : ''}`,
                icon: "error",
                button: "Ок",
            });
        }

        

        let getResultFiscalization;

        if (comparisonVersionExtension(versionExtension, '2.2.2')) {
            getResultFiscalization = fiscalization;
        } else {
            const requestTaskResultData = {
                host: device.host || 'http://127.0.0.1',
                port: device.port || 16732,
                login: device.login,
                password: device.password,
                type: 'getTaskResult',
                fiscalUUID: fiscalization.uuid || fiscalization.fiscalUUID,
            }

            getResultFiscalization = await dispatch(requestAtol(requestTaskResultData));
        }

        let error;
        if (getResultFiscalization.error) {
            error = getResultFiscalization.error;
        } else if (getResultFiscalization.results && getResultFiscalization.results[0] && getResultFiscalization.results[0].error) {
            error = getResultFiscalization.results[0].error;
        }

        if (error && error.code !== 0) {
            const { code, error_message, message, description} = error;
            let text = '';
            if (code) text += String(code);
            if (message) text += `. ${message}`;
            if (error_message) text +=` ${error_message}`;
            if (description) text += ` ${description}`;
            setLoading(false);
            return swal({
                title: "Ошибка возврата",
                text: text,
                icon: "error",
                dangerMode: true,
                button: "Ок"
            });
        }

        const data = {
            id: order.id,
            fiscalUUID: fiscalization.fiscalUUID || null,
            fiscalized: requestData.type === 'sell' ? true : false
        };

        dispatch(setFiscalDataOrder(data));

        const renderTime = (order) => {
            const time = parseInt(order.timeZone, 10) || 3;
            const baseOrderDate = order.visible_datetime || order.created_at;
            return moment.utc(baseOrderDate).add(time, 'hours').format('DD.MM.YYYY HH:mm');
        }

        const dataArticle = {
            typeTransaction: order.payment === 'cash' ? 'cash' : 'noncash',
            sum: order.totalPrice,
            name: 'Возврат заказа',
            notRefunded: true,
            typeMovementCash: 'refund_revenue',
            comment: `Возврат заказа от ${renderTime(order)} № ${order.id}`,
        }

        const addArticle = await dispatch(addArticleWorkingShift(dataArticle, workingShift, false));
        if (addArticle) return swal({
            title: "Возврат выполнен",
            icon: "success",
            button: "Ок",
        }).then(() => {
            onClose()
        });
    }

    if (loading) return (
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                        <div style={{...styles.tableLoading, marginTop: 100}}>
                            <div className="loader">
                                <div className="kt-spinner kt-spinner--lg kt-spinner--info">
                                </div>
                            </div>
                        </div>
                            <div style={{ color: 'black', fontSize: '1.3rem' }}>{loading === 'kkt' ? 'Ожидаем ответ от ККТ. Не закрывайте и не обновляйте страницу' : 'Загружаю данные. Не закрывайте и не обновляйте страницу'}</div>          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={{ maxWidth: '350px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> Возврат заказа </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: '320px' }}>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Кассир</div>                               
                                <Select
                                    placeholder='Кассир'
                                    value={cashier}
                                    onChange={(e) => setCashier(e)}
                                    options={availableCashiers}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                            <button disabled={isEmpty(cashier) ? true : false} type="button" onClick={onSubmit} className='btn btn-primary'>Возврат</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default withRouter(RefundOrderModal);